// Copyright 2026, Imprivata, Inc.  All rights reserved.

import type { AppConfig, AppIntegration } from '@api/types';
import MenuIcon from '../../../assets/icons/kabob_menu.svg?react';
import { Button } from '@imprivata-cloud/components';
import { Dropdown, type MenuProps, Tag } from 'antd';
import { useTranslation } from 'react-i18next';

interface ApplicationsRowProps {
  appIntegration: AppIntegration;
  appConfig?: AppConfig;
  onEdit: () => void;
}

const ApplicationsRow: React.FC<ApplicationsRowProps> = ({ appIntegration, appConfig, onEdit }) => {
  const { t } = useTranslation();
  return (
    <div className="applications-row">
      <div className="applications-row-name">{appIntegration.appDisplayName}</div>
      {appConfig?.samlEnabled === true && (
        <Tag color="orange" aria-label="saml-tag">
          {t('apps.row.saml-tag')}
        </Tag>
      )}
      <Dropdown
        menu={{
          items: [
            {
              key: 'edit',
              label: t('apps.row.edit'),
              onClick: onEdit,
            },
          ] satisfies MenuProps['items'],
        }}
        trigger={['click']}
        placement="bottomRight"
      >
        <Button type="text" icon={<MenuIcon />} aria-label="row-menu" />
      </Dropdown>
    </div>
  );
};

export default ApplicationsRow;
